import { Box } from '@mui/material';
import { EnabledDocuments } from '../../../utils/headers';
import { memo, useCallback } from 'react';
import DataTable from '../../../components/Table/DataTable';
import Loading from '../../../components/Loading';

function PermissionsDataTable({
    handleSelectPermission,
    handleDeletePermission,
    updatingPermission,
    drawerAction,
    deletingPermission,
    addingPermission,
    permisos
}: any) {
    const RenderTable = useCallback(() => {
        return (
            <DataTable
                headers={EnabledDocuments}
                loading={false}
                hideFooterPagination
                withActions={['edit', 'new'].includes(drawerAction) ? ['delete'] : []}
                options={permisos}
                handleDeleteAction={handleDeletePermission}
                disableRowSelectionOnClick={['view', 'new'].includes(drawerAction)}
                onRowClick={['edit'].includes(drawerAction) ? handleSelectPermission : null}
            />
        );
    }, [drawerAction, permisos, handleSelectPermission, handleDeletePermission]);
    return (
        <Box>
            {deletingPermission || addingPermission || updatingPermission ? (
                <Loading size="medium" />
            ) : (
                <RenderTable />
            )}
        </Box>
    );
}

export default memo(PermissionsDataTable);
